import React, { useRef } from 'react'
import { Button, Modal, Form, Radio, Dropdown, Menu, Select, Space, Divider } from 'antd'
import { ExclamationCircleOutlined, DownOutlined, UpOutlined, PlusOutlined } from '@ant-design/icons'
import { v4 as uuid } from 'uuid'
import { IblocMap, IblocTableCustom, IblocTableMap, IblocTablePonctuel, IblocText, IModule, moduleNames } from './util'
import '../adhoc/Modules.css'
import './style.css'
import { AddBlocElem, BlocMap, BlocTableCustom, BlocTablePontuel, BlocTableSurfacique, BlocText } from './Blocs'
import TextEditor from './TextEditor'

interface IProps {
  modules: IModule[]
  onSave: (modules: IModule[]) => void
}

export interface CustomWindow extends Window {
  cloudinary: any
}
declare let window: CustomWindow

export const Modules = (props: IProps) => {
  const modules: IModule[] = props.modules.map((e: IModule) => {
    switch (e.typeModule) {
      case "pageGarde":
        if (!Array.isArray(e.dataPageGarde?.blocs)) {
          if (e.dataPageGarde) {
            e.dataPageGarde = { ...e.dataPageGarde, blocs: [] }
          }
          else {
            e.dataPageGarde = { blocs: [], idLogoOrga: '' }
          }
        }
        break;
      case "methodologie":
        if (!Array.isArray(e.dataMethodologie?.blocs)) {
          e.dataMethodologie = { blocs: [] }
        }
        break;
      case "surfacique":
        if (!Array.isArray(e.dataSurfacique?.blocs)) {
          e.dataSurfacique = { ...e.dataSurfacique, blocs: [] }
        }
        break;
      case "ponctuel":
        if (!Array.isArray(e.dataPonctuel?.blocs)) {
          e.dataPonctuel = e.dataPonctuel ? {
            ...e.dataPonctuel, blocs: []
          } : {
            blocs: [],
            typeBloc: 'noBloc'
          }
        }
        break;
    }
    return e
  })

  const updateModule = (m: IModule) => {
    const newModules = modules.map((e) => (e.id === m.id ? m : e))
    props.onSave(newModules)
  }

  const openCloudinary = (m: IModule, imageSrc: 'logo' | 'carteStandard') => {
    // create the widget
    window.cloudinary
      .createUploadWidget(
        {
          cloudName: 'dohf0ighs',
          uploadPreset: 'pwkmtckx',
        },
        (error: any, result: any) => {
          if (result.event === 'success') {
            if (imageSrc === 'logo') {
              const newM: IModule = {
                ...m,
                dataPageGarde: m.dataPageGarde ? {
                  ...m.dataPageGarde,
                  cloudinaryData: {
                    assetId: result.info.asset_id,
                    path: result.info.path,
                    secureUrl: result.info.secure_url,
                  },
                } : {
                  blocs: [],
                  idLogoOrga: ''
                },
              }
              updateModule(newM)
            } else if (imageSrc === 'carteStandard') {
              const newM: IModule = {
                ...m,
                dataPageGarde: m.dataPageGarde ? {
                  ...m.dataPageGarde,
                  cloudinaryDataCarteStandard: {
                    assetId: result.info.asset_id,
                    path: result.info.path,
                    secureUrl: result.info.secure_url,
                  },
                } : {
                  blocs: [],
                  idLogoOrga: ''
                },
              }
              updateModule(newM)
            }
          }
        },
      )
      .open() // open up the widget after creation
  }
  // Information pour le package Jodit
  const editor = useRef(null)
  const config: any = {
    language: 'fr',
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    enter: 'BR',
    buttons:
      'source,bold,italic,underline,strikethrough,eraser,ul,ol,indent,outdent,align,font,fontsize,paragraph,image,table,undo,redo',
    inline: false,
    toolbarInlineForSelection: true,
    toolbarAdaptive: false,
    showPlaceholder: false,
    minHeight: '400 px',
  }
  const config_titre: any = {
    language: 'fr',
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    enter: 'BR',
    buttons:
      'source,bold,italic,underline,strikethrough,eraser,ul,ol,indent,outdent,align,font,fontsize,paragraph,image,table,undo,redo',
    inline: false,
    limitChars: 100,
    toolbarInlineForSelection: true,
    toolbarAdaptive: false,
    showPlaceholder: false,
    minHeight: '400 px',
  }

  const handleMenuClick = (e: string, m: IModule) => {
    if (e === 'clone') {
      const newModule = { ...m, id: uuid() }
      const newModules = modules.concat(newModule)
      props.onSave(newModules)
    } else if (e === 'delete') {
      Modal.confirm({
        title: 'Certain·e de vouloir supprimer ce module ?',
        icon: <ExclamationCircleOutlined />,
        content: 'vraiment certain·e ? ',
        onOk() {
          const newModules = modules.filter((e) => e.id !== m.id)
          props.onSave(newModules)
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    }
  }

  const handleArrowUpClick = (m: IModule) => {
    const oldIndex: number = modules.map((e) => e.id).indexOf(m.id)
    const sizeModules: number = modules.length
    const newModules = modules
    if (sizeModules > 1 && oldIndex > 0) {
      newModules.splice(oldIndex - 1, 0, newModules.splice(oldIndex, 1)[0])
      props.onSave(newModules)
    }
  }

  const handleArrowDownClick = (m: IModule) => {
    const oldIndex: number = modules.map((e) => e.id).indexOf(m.id)
    const sizeModules: number = modules.length
    const newModules = modules
    if (sizeModules > 1 && oldIndex < sizeModules - 1) {
      newModules.splice(oldIndex + 1, 0, newModules.splice(oldIndex, 1)[0])
      props.onSave(newModules)
    }
  }
  // Paramètres de select dans module surfacique
  const { Option } = Select

  const listeBloc = [{ value: 'noBloc', text: 'Pas de Bloc' }].concat(
    Array.from(Array(5).keys()).map((i) => ({ value: `bloc${i + 1}`, text: `Bloc ${i + 1}` })),
  )

  function addBloc(type: string, index: number, moduleId: string, moduleDataName: string) {
    var bloc: IblocText | IblocMap | IblocTableMap | IblocTablePonctuel | IblocTableCustom | null = null
    switch (type) {
      case 'text':
        bloc = { elemType: 'text', value: '' }
        break;
      case 'map':
        bloc = { elemType: 'map', rank: 'rg4', potentielChoice: null }
        break;
      case 'tableMap':
        bloc = { elemType: "tableMap", tableauColonnesMetrics: [], tableauColonnesProduits: [], tableMode: 'summarized' }
        break;
      case 'tablePonctuel':
        bloc = { elemType: 'tablePonctuel', colBloc: ['raisonSociale', 'adresse', 'codePostal', 'commune'] }
        break;
      case 'tableCustom':
        bloc = { elemType: "tableCustom", lines: [{ cols: [''], style: [undefined] }] }
        break;
    }
    let moduleIndex = props.modules.findIndex(e => e.id == moduleId)
    let module = props.modules[moduleIndex]
    if (bloc != null) {
      module?.[moduleDataName]?.blocs.splice(index, 0, bloc)
    }
    props.onSave(props.modules)
  }

  return (
    <div style={{ marginTop: 20, paddingTop: 20 }}>
      {props.modules.map((module: IModule, indexModule: number) => (
        <div key={uuid()} style={{ marginBottom: 20 }}>
          <Form.Item label="Type de module">
            <div className="topModule">
              <Radio.Group
                value={module.typeModule || ''}
                onChange={(e) => updateModule({
                  ...module,
                  typeModule: e.target.value, dataPageGarde: module.dataPageGarde || { blocs: [], idLogoOrga: '' },
                  dataMethodologie: module.dataMethodologie || { blocs: [] },
                  dataPonctuel: module.dataPonctuel || { blocs: [], typeBloc: 'noBloc' },
                  dataSurfacique: module.dataSurfacique || { blocs: [] }
                })}
              >
                {moduleNames.map((d) => (
                  <Radio key={d.id} value={d.id}>
                    {d.name}
                  </Radio>
                ))}
              </Radio.Group>
              <div>
                <div className="arrows">
                  <Button
                    icon={<DownOutlined />}
                    size="small"
                    style={{ marginRight: 10 }}
                    onClick={() => handleArrowDownClick(module)}
                  ></Button>
                  <Button
                    icon={<UpOutlined />}
                    size="small"
                    style={{ marginRight: 10 }}
                    onClick={() => handleArrowUpClick(module)}
                  ></Button>
                </div>
                <Dropdown.Button
                  trigger={['click']}
                  overlay={
                    <Menu onClick={(e) => handleMenuClick(e.key.toString(), module)}>
                      <Menu.Item key="clone">Cloner</Menu.Item>
                      <Menu.Item key="delete">Supprimer</Menu.Item>
                    </Menu>
                  }
                ></Dropdown.Button>
              </div>
            </div>
          </Form.Item>
          {/* ------------- Page de garde -------------------------------------------------          */}
          {module.typeModule === 'pageGarde' && (
            <div style={{ marginTop: 15 }}>
              {/* Logo organisation */}
              <Form.Item label="Logo">
                <div style={{ marginTop: 20 }}>
                  <Button
                    // type="primary"
                    className="btn widget-btn"
                    onClick={() => openCloudinary(module, 'logo')}
                  >
                    Charger logo organisation
                  </Button>
                </div>
                <div>
                  <p>L'Aperçu du Logo apparaîtra ci-dessous :</p>
                  {module.dataPageGarde?.cloudinaryData && (
                    <img
                      src={module.dataPageGarde.cloudinaryData.secureUrl}
                      className="displayed-image"
                    />
                  )}
                </div>
              </Form.Item>

              <Form.Item label="Titre de la page">
                <div style={{ marginTop: 20 }}>
                  <TextEditor
                    type={props.modules[indexModule].dataPageGarde?.titleType || 'title1'}
                    avoidDeleteBloc={true}
                    value={props.modules[indexModule].dataPageGarde?.title || ""}
                    uniqueId={"pageGarde" + indexModule}
                    callback={(type: 'title1' | 'title2' | 'title3' | 'text', value: string, remove: boolean) => {
                      var temp: IModule = { id: '' }
                      temp = Object.assign(temp, props.modules[indexModule])
                      if (temp.dataPageGarde) {
                        temp.dataPageGarde.title = value
                        temp.dataPageGarde.titleType = type
                      }
                      updateModule(temp)
                    }} />
                </div>
              </Form.Item>

              <AddBlocElem index={-1} module={module} typeData={'dataPageGarde'} addBloc={addBloc} blocsAvailable={["text", "map"]} />
              {module.dataPageGarde?.blocs.map((b: IblocText | IblocMap, index: number) => (
                <div key={"datapageGarde" + indexModule + index}>
                  {(b.elemType == "title3" || b.elemType == "text" || b.elemType == "title1" || b.elemType == "title2") && (
                    <BlocText indexModule={indexModule} index={index} blocData={b} module={module} updateModule={updateModule} />
                  )}
                  {b.elemType == "map" && (
                    <BlocMap module={module} blocData={b} index={index} updateModule={updateModule} openCloudinary={openCloudinary} />
                  )}
                  <AddBlocElem index={index} module={module} typeData={'dataPageGarde'} addBloc={addBloc} blocsAvailable={["text", "map"]} />
                </div>
              ))}
            </div>
          )}
          {/* ------------- methodologie -------------------------------------------------          */}
          {module.typeModule === 'methodologie' && (
            <div>
              <AddBlocElem index={-1} module={module} typeData={'dataMethodologie'} addBloc={addBloc} blocsAvailable={["text", "tableCustom"]} />
              {module.dataMethodologie?.blocs.map((b: IblocText | IblocTableCustom, index: number) => (
                <div key={"dataMethodo" + indexModule + index}>
                  {(b.elemType == "text" || b.elemType == "title1" || b.elemType == "title2" || b.elemType == "title3") && (
                    <BlocText indexModule={indexModule} index={index} blocData={b} module={module} updateModule={updateModule} />
                  )}
                  {b.elemType == "tableCustom" && (
                    <BlocTableCustom indexModule={indexModule} index={index} blocData={b} module={module} updateModule={updateModule} />
                  )}
                  <AddBlocElem index={index} module={module} typeData={'dataMethodologie'} addBloc={addBloc} blocsAvailable={["text", "tableCustom"]} />
                </div>
              ))}
            </div>
          )}
          {/* ------------- surfacique -------------------------------------------------          */}
          {
            module.typeModule === 'surfacique' && (
              <div>
                <AddBlocElem index={-1} module={module} typeData={'dataSurfacique'} addBloc={addBloc} blocsAvailable={["text", "tableMap", "map"]} />
                {module.dataSurfacique?.blocs?.map((b: IblocText | IblocTableMap | IblocMap, index: number) => (
                  <div key={"dataSurfacique" + indexModule + index}>
                    {(b.elemType == "text" || b.elemType == "title1" || b.elemType == "title2" || b.elemType == "title3") && (
                      <BlocText indexModule={indexModule} index={index} blocData={b} module={module} updateModule={updateModule} />
                    )}
                    {b.elemType == "tableMap" && (
                      <BlocTableSurfacique indexModule={indexModule} index={index} blocData={b} module={module} updateModule={updateModule} />
                    )}
                    {b.elemType == "map" && (
                      <BlocMap module={module} blocData={b} index={index} updateModule={updateModule} openCloudinary={openCloudinary} />
                    )}
                    <AddBlocElem index={index} module={module} typeData={'dataSurfacique'} addBloc={addBloc} blocsAvailable={["text", "tableMap", "map"]} />
                  </div>
                ))}
              </div>
            )
          }
          {/* ------------- ponctuel -------------------------------------------------          */}
          {
            module.typeModule === 'ponctuel' && (
              <div>
                <Form.Item label="Choix de la donnée Pdv (Bloc)">
                  <Select
                    defaultValue={module?.dataPonctuel?.typeBloc}
                    placeholder="bloc"
                    onChange={(x: 'noBloc' | 'bloc1' | 'bloc2' | 'bloc3' | 'bloc4' | 'bloc5') => {
                      if (module.dataPonctuel?.typeBloc) {
                        module.dataPonctuel.typeBloc = x
                      }
                    }}
                    onBlur={() => updateModule({ ...module, dataPonctuel: { typeBloc: module.dataPonctuel?.typeBloc || "noBloc", blocs: [] } })}
                  >
                    {listeBloc.map((x) => (
                      <Option key={x.value} value={x.value}>
                        {x.text}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <AddBlocElem index={-1} module={module} typeData={'dataPonctuel'} addBloc={addBloc} blocsAvailable={["text", "tablePonctuel", "map"]} />
                {module.dataPonctuel?.blocs.map((b: IblocText | IblocMap | IblocTablePonctuel, index) => (
                  <div key={"dataPonctuel" + indexModule + index}>
                    {(b.elemType == "text" || b.elemType == "title1" || b.elemType == "title2" || b.elemType == "title3") && (
                      <BlocText indexModule={indexModule} index={index} blocData={b} module={module} updateModule={updateModule} />
                    )}
                    {b.elemType == "tablePonctuel" && (
                      <BlocTablePontuel indexModule={indexModule} index={index} blocData={b} module={module} updateModule={updateModule} />
                    )}
                    {b.elemType == "map" && (
                      <BlocMap module={module} blocData={b} index={index} updateModule={updateModule} openCloudinary={openCloudinary} />
                    )}
                    <AddBlocElem index={index} module={module} typeData={'dataPonctuel'} addBloc={addBloc} blocsAvailable={["text", "tablePonctuel", "map"]} />
                  </div>
                ))}
              </div>
            )}
          < Divider style={{ borderWidth: 5, borderColor: '#1990FF' }} />
        </div>
      ))}

      <Button
        icon={<PlusOutlined />}
        style={{ marginTop: 30 }}
        onClick={() => {
          const newModule: IModule = { id: uuid(), typeModule: undefined }
          props.onSave(modules.concat([newModule]))
        }}
      >
        Ajouter module
      </Button>
    </div >
  )
}
